var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"influencer-edit","toptitle":"Influencer bearbeiten","title":_vm.influencer.name,"width":1200}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('influencer-form',{attrs:{"influencer":_vm.influencer,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }